export { default } from './svg/modal-full.svg';
